import React from 'react';
import {
  PolarAngleAxis,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
} from 'recharts';
import { IRadialGraph } from '@/types/explorer';
import { cn, colors } from '@/utils/styles';

interface Props {
  data: IRadialGraph[];
  className?: string;
  textClassName?: string;
}

function CircleChart(props: Props) {
  const data = props.data as any;
  const className = props.className || '';
  const textClassName = props.textClassName || '';

  return (
    <div
      className={cn(
        'relative flex h-[200px] w-full items-center justify-center',
        className,
      )}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart
          cx="50%"
          cy="50%"
          innerRadius="88%"
          outerRadius="100%"
          barSize={14}
          data={data}
          startAngle={450}
          endAngle={90}>
          <PolarAngleAxis
            type="number"
            domain={[0, 100]}
            angleAxisId={0}
            tick={false}
          />
          <RadialBar
            background={{ fill: colors.azure[400], opacity: 0.4 }}
            dataKey="value"
          />
        </RadialBarChart>
      </ResponsiveContainer>
      <div
        className={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-azure-400 text-4xl sm:text-5xl',
          textClassName,
        )}>
        {Math.round(data[0].value)}%
      </div>
    </div>
  );
}

export default CircleChart;
